import Types from '../types'

const initialState = {
    automationAssessment: null,
    selectedCredential: '',
    importServices: [],
    importStatus: null,
    allRegions: []
};
export default function stateFileReducer(state = initialState, action) {
    switch (action.type) {
        case Types.AUTOMATION_ASSESSMENT:
            return {
                ...state,
                automationAssessment: action.payload
            };
        case Types.STATEFILE_SELECTED_CREDENTIAL:
            return {
                ...state,
                selectedCredential: action.payload
            };
        case Types.STATEFILE_IMPORT_SERVICES:
            return {
                ...state,
                importServices: action.payload
            };
        case Types.STATEFILE_IMPORT_STATUS:
            return {
                ...state,
                importStatus: action.payload
            };
        case Types.REGIONS_BY_ACCOUNT:
            return {
                ...state,
                allRegions: action.payload
            };
        case Types.ASSESSMENT_HISTORY:
            return {
                ...state,
                assessmentHistories: action.payload
            }
        default:
            return state;
    }
}
